import { Fragment } from 'react';

import ContentLoader from 'react-content-loader';

export const IncludeExcludeListLoader = () => (
  <ContentLoader speed={2} viewBox="0 0 245 272">
    {Array.from({ length: 5 }).map((_, index) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: content is not dynamic
      <Fragment key={index}>
        <circle cx="6" cy={4 + index * 24} r="4" />
        <circle cx="18.5" cy={4 + index * 24} r="4" />
        <rect x="28" y={index * 24} rx="5" ry="4" width="215" height="8" />

        {/* Add a line after each row except the last one */}
        {index < 4 && <rect x="0" y={index * 24 + 4 + 12} width="245" height="1" fill="#ccc" />}
      </Fragment>
    ))}
  </ContentLoader>
);
